// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveContactTypeDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ContactTypeDTO from '../models/ContactTypeDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    contactTypeId: number | null | null;
    contactType: ContactTypeDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            contactTypeId: null,
            contactType: null,
        },
        initValues);
    },
    contactTypeId: 'contactTypeId',
    contactType: 'contactType',
}

interface Result extends ResultDTO {
    contactType: ContactTypeDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            contactType: null,
        },
        initValues);
    },
    contactType: 'contactType',
}

export { Request, Result };